import type {SessionSummaryDTO, SessionTrackDTO, SessionTrackPointDTO} from '../models/session.dto';
import type {SessionTrack, SessionTrackPoint, WorkSession} from '../models/session.model';

export const mapSessionSummaryDTOToModel = (dto: SessionSummaryDTO): WorkSession => ({
  id: dto.id,
  marketerId: dto.marketer_id,
  marketerName: dto.marketer_name,
  workDate: dto.work_date,
  clockInAt: new Date(dto.clock_in_at),
  clockOutAt: dto.clock_out_at ? new Date(dto.clock_out_at) : null,
  clockInLat: dto.clock_in_lat,
  clockInLng: dto.clock_in_lng,
  clockOutLat: dto.clock_out_lat,
  clockOutLng: dto.clock_out_lng,
  status: dto.status,
  totalDistanceMeters: dto.total_distance_meters,
  totalStoresVisited: dto.total_stores_visited,
  durationSeconds: dto.duration_seconds,
  roadSnapped: dto.road_snapped ?? false,
  finalizedAt: dto.finalized_at ? new Date(dto.finalized_at) : null
});

export const mapSessionTrackPointDTOToModel = (dto: SessionTrackPointDTO): SessionTrackPoint => ({
  lat: dto.lat,
  lng: dto.lng,
  recordedAt: new Date(dto.recorded_at),
  trackType: dto.track_type,
  accuracy: dto.accuracy,
  visitId: dto.visit_id,
  storeId: dto.store_id,
  storeName: dto.store_name
});

export const mapSessionTrackDTOToModel = (dto: SessionTrackDTO): SessionTrack => ({
  session: mapSessionSummaryDTOToModel(dto.session),
  segments: dto.segments.map((seg) => ({points: seg.points})),
  markers: dto.markers.map(mapSessionTrackPointDTOToModel),
  simplified: dto.simplified,
  roadSnapped: dto.road_snapped ?? false
});
